import React from "react";
import {
  Home, Building2, HardHat, ShieldCheck, Waves, Droplets, ThermometerSun,
  FileCheck2, Hammer, AudioLines, Gauge, ScanSearch, Wind, Crosshair, Zap,
  Cpu, FileText, Target,
} from "lucide-react";

const MAP = {
  Home, Building2, HardHat, ShieldCheck, Waves, Droplets, ThermometerSun,
  FileCheck2, Hammer, AudioLines, Gauge, ScanSearch, Wind, Crosshair, Zap,
  Cpu, FileText, Target,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Target;
  return <Cmp strokeWidth={1.5} {...props} />;
}
